<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Orders" childName="View Orders"></side-menu>

    <div class="content">
      <p
        @click="$router.push(`/event/${$route.params.id}/orders`)"
        style="text-decoration:underline; cursor:pointer"
      >
        BACK
      </p>
      <div class="dashboard">
        <heading :title="'Order Details'"></heading>
        <div>
          <h3>Order # {{ order.order_number }}</h3>
          <p>
            Ordered by {{ order.payment_info.name }} on
            {{ order.created_at | format_date_time }}
          </p>
          <table class="orders">
            <thead>
              <td>Ticket Buyer</td>
              <td>QTY</td>
              <td>Tickets</td>
              <td>Paid</td>
            </thead>
            <tbody>
              <tr v-for="(item, id) in line_items" :key="id">
                <td>{{ order.payment_info.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.name }}</td>
                <td>${{ item.total_price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;

export default {
  components: {
    "management-nav": managementBar,
    "side-menu": managementMenu,
  },
  data() {
    return {
      order: {},
      line_items: [],
    };
  },
  firestore() {
    return {
      order: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("orders")
        .doc(this.$route.params.order_id),
      line_items: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("orders")
        .doc(this.$route.params.order_id)
        .collection("line_items"),
    };
  },
};
</script>

<style></style>
